import { render, staticRenderFns } from "./work-orders.html?vue&type=template&id=7965c570&scoped=true&"
import script from "./work-orders.ts?vue&type=script&lang=js&"
export * from "./work-orders.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965c570",
  null
  
)

export default component.exports